<script setup lang="ts">
import { ref } from "vue";
import ToolTip from "../../ToolTip.vue";
import { locale } from "../../../locale";
import PopoverMoreListNew from "../../PopoverMoreListNew.vue";
const btn = ref<HTMLElement | null>(null);
const opened = ref<HTMLElement | null>(null)
</script>
<template>
  <button ref="btn" class="settings-button" @click="opened = btn">
    <svg width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8535 2.98595C15.8535 2.21491 16.051 1.67424 16.4459 1.36395C16.8502 1.04425 17.3392 0.884399 17.9128 0.884399C18.4863 0.884399 18.9753 1.04425 19.3796 1.36395C19.7933 1.67424 20.0002 2.21491 20.0002 2.98595C20.0002 3.73818 19.7933 4.28355 19.3796 4.62206C18.9753 4.95116 18.4863 5.11571 17.9128 5.11571C17.3392 5.11571 16.8502 4.95116 16.4459 4.62206C16.051 4.28355 15.8535 3.73818 15.8535 2.98595Z"
        fill="white" />
      <path
        d="M7.92676 2.98595C7.92676 2.21491 8.12422 1.67424 8.51914 1.36395C8.92347 1.04425 9.41242 0.884399 9.986 0.884399C10.5596 0.884399 11.0485 1.04425 11.4529 1.36395C11.8666 1.67424 12.0734 2.21491 12.0734 2.98595C12.0734 3.73818 11.8666 4.28355 11.4529 4.62206C11.0485 4.95116 10.5596 5.11571 9.986 5.11571C9.41242 5.11571 8.92347 4.95116 8.51914 4.62206C8.12422 4.28355 7.92676 3.73818 7.92676 2.98595Z"
        fill="white" />
      <path
        d="M0 2.98595C0 2.21491 0.197461 1.67424 0.592384 1.36395C0.996709 1.04425 1.48566 0.884399 2.05924 0.884399C2.63282 0.884399 3.12177 1.04425 3.52609 1.36395C3.93982 1.67424 4.14669 2.21491 4.14669 2.98595C4.14669 3.73818 3.93982 4.28355 3.52609 4.62206C3.12177 4.95116 2.63282 5.11571 2.05924 5.11571C1.48566 5.11571 0.996709 4.95116 0.592384 4.62206C0.197461 4.28355 0 3.73818 0 2.98595Z"
        fill="white" />
    </svg>
    <ToolTip v-if="!opened" :placement="'top'" :reference="btn">{{ locale.more }}</ToolTip>
  </button>
  <PopoverMoreListNew v-if="opened" :reference="opened" @close="opened = null" />
</template>
<style scoped>
.settings-button {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: rgba(73, 73, 73, 0.85);
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  cursor: pointer;
}

.settings-button:hover {
  background-color: #494949;
}

.settings-button:active {
  background-color: rgba(41, 41, 41, 0.85);
}

.settings-button:focus {
  outline: none;
}
</style>
